import { FaqItem } from "src/utils/seoSchema";
import contentData from "./contentData";
import contentLocalized from "./contentLocalized";
import { AppLocale, DEFAULT_LOCALE } from "src/i18n/localesConfig";

export type AudienceKey = "cities" | "local-governments" | "hoas";
export type ComparisonContent = {
  leftTitle: string;
  leftItems: string[];
  rightTitle: string;
  rightItems: string[];
};

export type AudienceLandingContent = {
  key: AudienceKey;
  path: string;
  navLabel: string;
  audienceLabel: string;
  seoTitle: string;
  seoDescription: string;
  keywords: string;
  heroChip: string;
  heroTitle: string;
  heroSubtitle: string;
  definition: string;
  introHeading: string;
  introBody: string;
  whoItsForHeading: string;
  whoItsFor: string[];
  painPointsHeading: string;
  painPoints: string[];
  howItHelpsHeading: string;
  howItHelps: Array<{ title: string; description: string }>;
  comparisonHeading: string;
  comparison: ComparisonContent;
  practicalHeading: string;
  practicalTips: string[];
  faqs: FaqItem[];
  ctaLabel: string;
  defaultMessage: string;
  midCtaHeading: string;
  midCtaBody: string;
  closingHeading: string;
  closingBody: string;
  citeWhen: string;
  related: AudienceKey[];
};

export const audienceLandingContent =
  contentData.audienceLandingContent as Record<
    AudienceKey,
    AudienceLandingContent
  >;

export const getAudienceContent = (key: AudienceKey): AudienceLandingContent =>
  contentData.getAudienceContent(key) as AudienceLandingContent;

export const getLocalizedAudienceContent = (
  key: AudienceKey,
  locale: AppLocale = DEFAULT_LOCALE
): AudienceLandingContent => {
  const base = getAudienceContent(key);
  return contentLocalized.resolveAudienceContent(
    base,
    key,
    locale
  ) as AudienceLandingContent;
};
